'use es6';

import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { PANEL, UniversalSidebarUsePropType } from 'customer-data-sidebar/universal/constants/UniversalSidebarUseConstants';
import StyledUniversalSidebarPanel from 'customer-data-sidebar/universal/StyledUniversalSidebarPanel';
import { jsx as _jsx } from "react/jsx-runtime";
const UniversalSidebarPreviewPanel = ({
  children,
  use
}) => {
  // If the use="panel", the sidebar should already be in a UIPanel rendered by the consumer
  if (use === PANEL) {
    return /*#__PURE__*/_jsx(Fragment, {
      children: children
    });
  }
  return /*#__PURE__*/_jsx(StyledUniversalSidebarPanel, {
    "data-selenium-test": "sidebar-preview-panel",
    children: children
  });
};
UniversalSidebarPreviewPanel.propTypes = {
  children: PropTypes.node.isRequired,
  use: UniversalSidebarUsePropType.isRequired
};
export default UniversalSidebarPreviewPanel;